import { getZombieInstanceFromPrimaryKey } from '@iotv/datamodel-core';
import qs from 'qs';
import { loadable } from 'react-lazily/loadable';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { extractViewObjectFromNodeEdgeMapper } from '../data/daoFunctions/nodeEdgeMapperTransform';
import { TransactionFunctions, UserFunctions } from '../redux/actions/AppActionFunctions/AppActions';
const ThingsView = loadable(() => import('../components/ThingsView/ThingsView')).default;
const debug = process.env.REACT_APP_DEBUG && false;
const mapStateToProps = (state, ownProps) => {
    debug && console.log('ThingsView own props', ownProps);
    const { location, params } = ownProps;
    const applicationData = state.AppReducer.applicationData;
    const typeFilter = ownProps.params.type;
    const { contextObjectSk } = qs.parse(location.search, { ignoreQueryPrefix: true });
    let singleNodeEdgeMapper = undefined;
    debug && console.log('ThingsViewContainer ownProps', { ownProps, contextObjectSk });
    const contextObject = applicationData.getItem(getZombieInstanceFromPrimaryKey(contextObjectSk ?? 'never'));
    if (contextObject) {
        singleNodeEdgeMapper = applicationData.extractSingleNodeEdgeMapper(contextObject);
    }
    debug && console.log('ThingsViewContainer singleNodeEdgeMapper', { applicationData, contextObject, singleNodeEdgeMapper });
    const requiredTypes = typeFilter ? [typeFilter] : Object.keys(applicationData.containedTypes());
    const viewObjects = requiredTypes.reduce((a, c) => {
        const nodesOfType = applicationData.getNodesOfType(c);
        nodesOfType.forEach((node) => {
            a.push(extractViewObjectFromNodeEdgeMapper(applicationData, node));
        });
        return a;
    }, []);
    return {
        applicationData,
        isAuthenticated: state.AccessReducer.isAuthenticated,
        cognitoUser: state.AccessReducer.cognitoUser,
        userGroupRoles: state.AppReducer.userGroupRoles,
        userSelectedGroup: state.AppReducer.userSelectedGroup,
        user: state.AppReducer.user,
        contextCustomer: state.AppReducer.contextCustomer,
        contextObject: state.AppReducer.contextCustomer,
        singleNodeEdgeMapper,
        childFirstGeofences: [],
        viewObjects,
        useSpecializedViews: state.AppReducer.useSpecializedViews,
        redirect: state.AppReducer.redirect,
        thingViewMap: state.AppReducer.thingViewMap,
        isSmallView: state.AppReducer.isSmallView,
    };
};
const mapDispatchToProps = (dispatch, ownProps) => {
    return {
        init: (cognitoUser, userGroupRoles) => {
            debug && console.log('ThingsView Container requested init', ownProps);
        },
        userFunctions: bindActionCreators(UserFunctions, dispatch),
        transactionFunctions: bindActionCreators(TransactionFunctions, dispatch),
    };
};
export default connect(mapStateToProps, mapDispatchToProps)(ThingsView);
